import React, { useState, useEffect } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'
import Typography from '../../UniformComponents/Typography'
import Input from '../form/Input'
import Date from '../form/Date'
import RecordTag from '../RecordTags'

const AddSurveyBranchModal = (props) => {
    const {
        store, showAddBranchModal, toggleAddSurveyBranchModal, fetchBranches, nextBranchNum,
    } = props
    const [formInputs, setFormInputs] = useState({})
    const [recordTags, setRecordTags] = useState({})
    const [fieldValidation, setFieldValidation] = useState({})

    useEffect(() => {
        setFormInputs({ surveyName: `${store.survey.title} - Branch ${nextBranchNum}` })
        setRecordTags(store.recordTags)
    }, [nextBranchNum])

    const validate = () => {
        const valid = Object.keys(fieldValidation).reduce((isValid, k) => {
            if (!isValid) {
                fieldValidation[k]({ name: k, value: formInputs[k] }, true)
                return false
            }
            return fieldValidation[k]({ name: k, value: formInputs[k] }, true)
        }, true)
        return { error: !valid }
    }

    const addBranch = async () => {
        if (validate().error) return
        await store.addSurveyBranch(formInputs, recordTags)
        await fetchBranches()
        toggleAddSurveyBranchModal()
    }

    const blurRecordtag = ({ name, value }) => {
        setRecordTags({ ...recordTags, [name]: value })
    }

    const register = (name, validateFunc) => {
        if (name) {
            fieldValidation[name] = validateFunc
            setFieldValidation({ ...fieldValidation, [name]: validateFunc })
        }
    }

    const unregister = () => setFieldValidation({})

    const endDateValidation = ({ value }) => value.isAfter(formInputs.startDate) || value.isSame(formInputs.startDate)

    return (
        <Modal show={showAddBranchModal} onClose={() => toggleAddSurveyBranchModal()}>
            <div className="uc-modal__header">
                <Typography type="h2">{i18n.t('settings.surveyBranching.addBranch')}</Typography>
            </div>
            <div
                style={{
                    marginInline: '32px', display: 'flex', flexDirection: 'column', gap: '16px', paddingTop: '16px',
                }}
                className="addSurveyBranchForm"
            >
                <div style={{
                    display: 'flex', flexDirection: 'column', gap: '16px',
                }}
                >
                    <Input
                        name="surveyName"
                        label={i18n.t('settings.surveyBranching.editBranchTitle')}
                        placeholder=""
                        onBlur={({ value }) => setFormInputs({ ...formInputs, surveyName: value })}
                        defaultValue={`${store.survey.title} - Branch ${nextBranchNum}`}
                        isMandatory
                        register={register}
                        unregister={unregister}
                        emptyError
                    />
                    <Date
                        name="startDate"
                        label={i18n.t('start_date')}
                        placeholder={i18n.t('start_date')}
                        onBlur={({ value }) => setFormInputs({ ...formInputs, startDate: value })}
                        dateFormat="DD/MM/YYYY"
                        allowManualDateEdit
                        isMandatory
                        register={register}
                        unregister={unregister}
                        emptyError
                        dontValidateOnBlur
                    />
                    <Date
                        name="endDate"
                        label={i18n.t('end_date')}
                        placeholder={i18n.t('end_date')}
                        onBlur={({ value }) => setFormInputs({ ...formInputs, endDate: value })}
                        dateFormat="DD/MM/YYYY"
                        allowManualDateEdit
                        isMandatory
                        register={register}
                        unregister={unregister}
                        emptyError
                        validate={endDateValidation}
                        dontValidateOnBlur
                    />
                    <RecordTag
                        onBlur={blurRecordtag}
                        availableTags={store.availableTags}
                        values={recordTags}
                    />
                </div>
                <div className="uc-modal__button-panel" style={{ justifyContent: 'space-between' }}>
                    <Button
                        cssClass="regular"
                        variant="tertiary"
                        label={i18n.t('cancel')}
                        onClick={toggleAddSurveyBranchModal}
                    />
                    <Button
                        cssClass="regular"
                        variant="secondary"
                        label={i18n.t('settings.surveyBranching.addSurveyBranch')}
                        onClick={addBranch}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default observer(AddSurveyBranchModal)
